import React from "react";
import Marty from "marty";

let Trademark = React.createClass({
    render() {
        return (
            <section className="eo-sub-view trademark">
                <h2>Trademark usage & policy</h2>
                <p>This Trademark Usage Policy provides guidance as to the proper use of the trademarks and logos, (collectively “Trademarks”) of eero inc. (“eero”) by our licensees, authorized
                    resellers, and other parties who have obtained eero’s consent to use eero’s Trademarks on their materials, including instructional materials, websites, packaging, labels or
                    elsewhere. This policy helps us protect our valuable trademark rights. If you’re a licensee of any eero Trademarks or an authorized reseller of eero products and have specific
                    trademark usage guidelines in your agreement with us, please follow those guidelines.</p>
                <p>eeroTM, eeroTM (stylized), and the eero logo are trademarks licensed by eero inc. The absence of a eero Trademark from this page does not constitute a waiver of trademark or other
                    intellectual property rights of eero concerning that name or logo.</p>
                <p>When referring to eero Trademarks, always include the proper notice after the name and logo, as described above. Always use the complete Trademark in all communications. Never
                    abbreviate an eero Trademark or create an acronym from them. When using an eero Trademark, never vary the spelling, add or delete hyphens, make two words one, or make one word two.
                    Do not combine eero Trademarks with your or any third-party names or trademarks. Do not use an eero Trademark as a verb, and never make an eero Trademark possessive or plural. Use
                    of eero logos may only be made under a separate written license from eero. eero Trademarks may not be used as part of the product name for any third-party product. Products may be
                    co-branded with an eero mark only by written agreement with eero. By using an eero Trademark, you are acknowledging that eero is the owner of all right, title, and interest in the
                    Trademark, that all use of the eero Trademark inures to eero’s benefit, that you will not interfere with or challenge eero’s rights in the Trademark, and that you will not use the
                    eero Trademark in a way that violates any law or harms the eero brand. No person or entity may reproduce or use (or authorize the reproduction or use of) any eero Trademark in any
                    manner other than expressly authorized by eero.</p>
            </section>
        );
    },
    getInitialState() {
        return {};
    }
});

export default Marty.createContainer(Trademark, {});


/*small TM*/


/** WEBPACK FOOTER **
 ** ./app/views/anonymous/views/legal/views/trademark/Handler.js
 **/